import React, { useState, useEffect, useContext, useMemo } from 'react';
import { Link } from 'react-router-dom';
import MuiLink from '@mui/material/Link';
import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet-async';
import {
  getVideoPages,
  deleteVideoPage,
  saveVideoPage,
} from 'services/videoPages.service';
import toast, { snack } from 'utils/toast';
import VideoTable from '../components/VideoTable';
import Typography from '@mui/material/Typography';
import Access, { MODULES, ACTIONS } from 'components/Access';

import { VideosContext } from '../index';

const AllVideos = ({}) => {
  const [data, setData] = useState();
  const { query, filterVideos } = useContext(VideosContext);
  useEffect(() => {
    getVideoPages().then(setData);
  }, []);

  const filteredVideos = useMemo(() => {
    return filterVideos(data);
  }, [query, data]);

  const toggleFavorite = (row) => {
    let tempArr = [...data];
    tempArr.forEach((ele) => {
      if (ele === row) ele.favorite = ele.favorite === '0' ? '1' : '0';
    });
    setData(tempArr);
  };

  const onAction = async (action, row) => {
    try {
      switch (action) {
        case 'favorite': {
          await saveVideoPage({
            hash: row.hash,
            favorite: '1',
          });
          toggleFavorite(row);
          snack.success('Page added to favorite.');
          break;
        }
        case 'unfavorite': {
          await saveVideoPage({
            hash: row.hash,
            favorite: '0',
          });
          toggleFavorite(row);
          snack.success('Page removed from favorite.');
          break;
        }
        case 'delete': {
          await deleteVideoPage(row.hash);
          setData(data.filter((i) => i !== row));
          snack.success('Page deleted.');
          break;
        }
      }
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <Box>
      <Helmet title="All pages" />
      <VideoTable
        loading={!data}
        data={filteredVideos}
        onAction={onAction}
        noDataMessage={
          <Typography align="center" variant="subtitle2" color="textSecondary">
            No Pages found.{' '}
            <Access action={ACTIONS.MODIFY} module={MODULES.VIDEO_NOTES}>
              <MuiLink component={Link} to="/pages/create">
                Create Page
              </MuiLink>
            </Access>
          </Typography>
        }
      />
    </Box>
  );
};

export default AllVideos;
